import { put, select, take } from 'redux-saga/effects';

// internal
import * as Action from '@app/store/typings/actions/user.d';
import { ProjectType } from '@app/store/typings/actions/project';
import * as Service from '@app/services/user';
import { listRoleInBrandAdmin } from '@app/services/brand';
import { listUsersInProject } from '@app/services/project';
import { listGroups } from '@app/services/project';
import { handleError } from '@app/utils/service';
import { ResponseListData } from '@app/typings/services/service.d';
import { UserDataInBrand } from '@app/typings/services/user';
import { RootState } from '@app/store/typings/state/root';

export function* fetchDataSelect({ payload }: Action.FetchSelectUser) {
  try {
    const { data } = yield Service.fetchZoneSelect(payload);
    if (data.success) {
      yield put<Action.UserType>({
        type: 'KEY_USER_SELECT_SET_DATA',
        payload: data.data.map((value: ResponseListData) => {
          return {
            value: value._id,
            label: value.firstName ? `${value.firstName} ${value.lastName}` : '-',
          };
        }),
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchUserByName({ payload }: Action.FetchUserByName) {
  try {
    const { data } = yield Service.fetchUserByName(payload);
    if (data.success) {
      yield put<Action.UserType>({
        type: 'KEY_USER_SELECT_SET_DATA',
        payload: data.data.map((value: ResponseListData) => {
          return {
            value: value._id,
            label: value.firstName ? `${value.firstName} ${value.lastName}` : '-',
          };
        }),
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchMyuser() {
  try {
    const { data } = yield Service.fetchMyUser();
    if (data.success) {
      yield put<Action.UserType>({
        type: 'KEY_USER_MYUSER_SET_DATA',
        payload: data.data,
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchCurrentUserInBrand({ payload }: Action.FetchUserInBrandWithId) {
  try {
    const { data } = yield Service.fetchUserWithId(payload);
    if (data.success) {
      yield put<Action.UserType>({
        type: 'KEY_USER_INBRAND_SETCURRENT',
        payload: data.data,
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchCurrentUserInProject({ payload }: Action.FetchUserInProjectWithId) {
  try {
    const { data } = yield Service.fetchUserWithId(payload);
    if (data.success) {
      yield put<Action.UserType>({
        type: 'KEY_USER_INPROJECT_SETCURRENT',
        payload: data.data,
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchUserInBrand({ payload }: Action.FetchUserInBrand) {
  try {
    const check: boolean = yield select((state: RootState) => state.brand.currentBrand._id);
    if (!check) {
      yield take('KEY_BRAND_SET_WITHID');
    }
    const brandId: string = yield select((state: RootState) => state.brand.currentBrand._id);
    const { data } = yield listRoleInBrandAdmin(brandId, payload.offset, payload.limit);
    if (data.success) {
      let usersData: UserDataInBrand[] = data.data;

      yield put<Action.UserType>({
        type: 'KEY_USER_BRAND_SETMETA',
        payload: {
          offset: data.meta.offset,
          limit: data.meta.limit,
          total: data.meta.total,
        },
      });
      yield put<Action.UserType>({
        type: 'KEY_USER_INBRAND_SETDATA',
        payload: usersData,
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchUserInProject({ payload }: Action.FetchUserInProject) {
  const { filters, pages } = payload;
  try {
    const check: boolean = yield select((state: RootState) => state.project.currentProject._id);
    if (!check) {
      yield take('KEY_PROJECT_SET_WITHID');
    }
    const projectId: string = yield select((state: RootState) => state.project.currentProject._id);
    const { data } = yield listUsersInProject({
      projectId,
      offset: pages.offset,
      limit: pages.limit,
      firstName: filters?.firstName || undefined,
      lastName: filters?.lastName || undefined,
      email: filters?.email || undefined,
      phone: filters?.phone || undefined,
      roleName: filters?.roleName || undefined,
      status: filters?.status || undefined,
    });
    if (data.success) {
      yield put<Action.UserType>({
        type: 'KEY_USER_INPROJECT_SETDATA',
        payload: { data: data.data, meta: data.meta },
      });
      yield put<ProjectType>({
        type: 'KEY_PROJECT_CLEAR_LOADING',
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* extendForListGroupName(projectId: string) {
  try {
    const { data } = yield listGroups({ projectId, limit: 0, offset: 0 });
    if (data.success) {
      yield put<ProjectType>({
        type: 'KEY_PROJECT_SET_DATA_GROUPS',
        payload: {
          data: data.data,
          meta: data.meta,
        },
      });
    }
  } catch (error) {
    handleError(error);
  }
}

export function* fetchUserInvite() {
  try {
    const { data } = yield Service.fetchMyUser(true);
    if (data.success) {
      yield put<Action.UserType>({
        type: 'KEY_USER_MYUSER_SET_DATA',
        payload: data.data,
      });
    }
  } catch (error) {
    handleError(error);
  }
}
